import { Component, ViewEncapsulation, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter, OnDestroy, OnChanges, inject } from '@angular/core';

import { ModalServiceService } from '../../services/modal-service.service';
import { NgClass } from '@angular/common';
/**
 * The component ModalBasicComponent
 *
 * @export
 * @class ModalBasicComponent
 * @typedef {ModalBasicComponent}
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
    selector: 'app-modal-basic',
    templateUrl: './modal-basic.component.html',
    styleUrls: ['./modal-basic.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass]
})
export class ModalBasicComponent implements OnInit, OnDestroy {
  private modalService = inject(ModalServiceService);
  private el = inject(ElementRef);

  /**
   * Id
   *
   * @type {string}
   */
  @Input()
  id!: string;

  /**
   * Button array
   *
   * @type {[]}
   */
  @Input() buttons: any[] = [];

  /**
   * Icon image path
   *
   * @type {string}
   */
  @Input() iconImage: string;

  /**
   * Is open emitter
   *
   * @type {*}
   */
  @Output() isOpen = new EventEmitter();

  /**
   * Element
   *
   * @private
   * @type {*}
   */
  private element: any;
  /**
   * Status of modal
   *
   * @type {boolean}
   */
  @Input() showModal: boolean;

  /**
   * Hide or show the icon to close modal
   *
   * @type {boolean}
   */
  @Input() showCloseIcon: boolean;
  /**
   * Show modal on the top
   *
   * @type {?boolean}
   */
  @Input() isModalForm?: boolean;
  /**
   * Content of the component
   *
   * @type {ElementRef}
   */
  @ViewChild('content')
  content!: ElementRef;

  /**
   * Changes position of close boton
   *
   * @type {?boolean}
   */
  @Input() centerIcon?: boolean;
  /**
   * Changes the size of the modal
   */

  /**
   * Set or not the dynamic size on the modal
   *
   * @type {?boolean}
   */
  @Input() dinamicSize?: boolean;

   /**
    * Prevent close modal when click outside of the content box
    *
    * @type {?boolean}
    */
  @Input() preventBackdropClose?: boolean = false;

  /**
   * The Constructor is a default method of the class that is executed when the class is instantiated and ensures proper initialization of fields in the class and its subclasses.
   * Creates an instance of ModalBasicComponent.
   *
   * @constructor
   * @param {ModalServiceService} modalService Modal instance service
   * @param {ElementRef} el Instance from some dom element
   */
  constructor() {
    const el = this.el;

    this.showCloseIcon = true;
    this.showModal = false;
    this.isModalForm = false;
    this.centerIcon = false;
    this.dinamicSize = false;
    this.iconImage = '';
    this.buttons = [];

    this.element = el.nativeElement;
  }

  /**
   * Function that is executed before rendering
   */
  ngOnInit(): void {
    if (!this.id) {
      // console.log('el modal necesita un identificador')
      return;
    }

    // console.log(this.buttons)

    document.body.appendChild(this.element);

  if (!this.preventBackdropClose) {
    this.element.addEventListener(
      'click',
      (el: { target: { className: string } }) => {
        if (el.target.className === 'modal-basic') {
          this.close();
          this.isOpen.emit(false);
        }
      },
    );
  }

    this.modalService.add(this);
    // console.log(this.element)

    if (this.showModal) {
      this.isOpen.emit(true);
      this.element.style.display = 'block';
      document.body.classList.add('modal-open');
    }
  }

  /**
   * ToDo
   *
   * @param {*} buttos
   */
  setButtons(buttos: any[]) {
    this.buttons = buttos;
  }

  /**
   * Remove modal service and element instance
   */
  ngOnDestroy() {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  /**
   * Handled open modal
   */
  open(): void {
    this.isOpen.emit(true);
    this.element.style.display = 'block';
    document.body.classList.add('modal-open');
  }

  /**
   * Function to hide the modal.
   */
  close(): void {
    this.isOpen.emit(false);
    this.element.style.display = 'none';
    document.body.classList.remove('modal-open');
    // this.showModal = false;
    // this.close.emit(this.showModal);
  }
}
